var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
var ButtonArrowI = styled.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: 0.2s all ease-out;\n  transform: ", ";\n  ", "\n  ", ";\n"], ["\n  transition: 0.2s all ease-out;\n  transform: ", ";\n  ", "\n  ", ";\n"])), function (props) { return (props.isOpen ? "rotate(-180deg)" : "none"); }, function (props) { return (props.color ? "color: " + props.color + ";" : ""); }, function (props) { return (props.fontSize ? "font-size: " + props.fontSize + "px" : ""); });
var ButtonArrow = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx(ButtonArrowI, __assign({ className: "fas fa-chevron-down " + className }, props), void 0));
};
export default ButtonArrow;
var templateObject_1;
//# sourceMappingURL=ButtonArrow.js.map